import React from 'react'

interface Props {
  children?: React.ReactNode;
}

class ErrorBoundary extends React.PureComponent<Props> {
  state = { hasError: false }

  static getDerivedStateFromError(error) {
    // 更新 state 使下一次渲染能够显示降级后的 UI
    return { hasError: error };
  }

  componentDidUpdate() {
    this.setState({
      hasError: null
    })
  }

  componentDidCatch(error, errorInfo) {
    // 您可以将这些信息上报给错误监控服务
    console.error("Uncaught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // 您可以自定义降级后的 UI 并返回
      return (
        <div style={{textAlign: 'center'}}>
          <div>页面加载失败</div>
          <div>{JSON.stringify(this.state.hasError)}</div>
        </div>
      )
    }

    return this.props.children; 
  }
}

export default ErrorBoundary
